import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {SelectFilterDataModule} from '../../../../../core/component/select-filter-data/select-filter-data.module';
import {ExamFormDefinitionSummarySelectFilterComponent} from './exam-form-definition-summary-select-filter.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        SelectFilterDataModule,
    ],
    declarations: [
        ExamFormDefinitionSummarySelectFilterComponent
    ],
    exports: [
        ExamFormDefinitionSummarySelectFilterComponent
    ]
})
export class ExamFormDefinitionSummarySelectFilterModule {
}
